function transformUser(obj = {}) {
    const { applicationRoles, email, displayName, name, osuid, given_name = '', family_name = '', "cognito:groups": cognitoGroups } = obj
    const formattedUser = {
        applicationRoles: applicationRoles,
        cognitoGroups: cognitoGroups,
        email: email,
        name: displayName ? displayName : name,
        fullName: `${name} ${family_name}`,
        osuid: osuid,
        initials: `${given_name && given_name.charAt(0)}${family_name && family_name.charAt(0)}`.toUpperCase()
    }

    return formattedUser
}

export { transformUser }